import { defineComponent as _defineComponent } from 'vue';
import CompanyLayout from '@/Layouts/Company.vue';
import { Head } from '@inertiajs/inertia-vue3';
import InputText from 'primevue/inputtext';
import ToggleButton from 'primevue/togglebutton';
import { computed, onMounted, ref } from 'vue';
import LinkButton from '../../Components/LinkButton.vue';
import { usePageProps } from '../../Plugins/page-props';
import Button from 'primevue/button';
import { Inertia } from '@inertiajs/inertia';
import { useRoute } from '../../Plugins/ziggy';
export default /*#__PURE__*/ _defineComponent({
    __name: 'OrchardsList',
    props: {
        orchards: {
            type: Array,
            default: () => [],
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const pageProps = usePageProps();
        const user = pageProps.user();
        const company = pageProps.company();
        const isAdmin = user.admin;
        const searchInput = ref('');
        const route = useRoute();
        const routePrefix = (isAdmin ? 'admin.companies.' : '') + 'orchards.';
        const routeParams = (orchardId) => {
            const params = isAdmin ? [company.id] : [];
            params.push(orchardId);
            return params;
        };
        const map = ref();
        const fitMapBounds = () => {
            const bounds = new google.maps.LatLngBounds();
            props.orchards?.forEach((orchard) => {
                bounds.extend({
                    lat: Number(orchard.latitude),
                    lng: Number(orchard.longitude),
                });
            });
            map.value.$mapPromise.then((mapObject) => {
                mapObject.fitBounds(bounds);
            });
        };
        const openedMarkerId = ref(null);
        const openMarker = (id) => (openedMarkerId.value = id);
        const filteredOrchards = computed(() => {
            return props.orchards.filter((orchard) => {
                return orchard.name.toLowerCase().includes(searchInput.value.toLowerCase());
            });
        });
        const openManagement = (orchardId) => {
            const routeData = {
                company: pageProps.isAdmin() ? company.id : undefined,
                orchard: orchardId,
            };
            Inertia.visit(route(`${routePrefix}manage`, routeData));
        };
        onMounted(() => {
            fitMapBounds();
        });
        const __returned__ = { pageProps, user, company, isAdmin, searchInput, route, props, routePrefix, routeParams, map, fitMapBounds, openedMarkerId, openMarker, filteredOrchards, openManagement, CompanyLayout, get Head() { return Head; }, get InputText() { return InputText; }, get Button() { return Button; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
